module.exports = __webpack_public_path__ + "img/logo.8672a524.png";